import { render, staticRenderFns } from "./OwnSuccessStories.vue?vue&type=template&id=376b9cd4&scoped=true"
import script from "./OwnSuccessStories.vue?vue&type=script&lang=js"
export * from "./OwnSuccessStories.vue?vue&type=script&lang=js"
import style0 from "./OwnSuccessStories.vue?vue&type=style&index=0&id=376b9cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376b9cd4",
  null
  
)

export default component.exports